import React, { ReactNode } from 'react';

import './filters.css';

type Props = {
  children?: ReactNode;
};

const FiltersChipsContainer = ({ children }: Props) => {
  return <div styleName="filter-chips-container">{children}</div>;
};

export default FiltersChipsContainer;
